import React, { Fragment, useEffect, useState } from 'react'
import Header from '../../components/header/Header'
import PageTitle2 from '../../components/pagetitle/PageTitle2'
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { API_URL } from '../../constant'

function MyWalletPage() {
  const [topCoinTotal, setTopCoinTotal] = useState(0);
  const [topCoinPoints, setTopCoinPoints] = useState(Array(12).fill(0));
  const [topCoinLoading, setTopCoinLoading] = useState(true);

  const [allocatedAmount, setAllocatedAmount] = useState(0);
  const [allocatedLoading, setAllocatedLoading] = useState(true);

  const currentMonthIndex = new Date().getMonth();

  useEffect(() => {
    const fetchTopCoins = async () => {
      try {
        const response = await fetch(`${API_URL}/api/public/wallet/chart-data`);
        if (!response.ok) {
          throw new Error('Failed to fetch chart data');
        }
        const data = await response.json();
        const points = Array.isArray(data?.monthly_points) ? data.monthly_points : [];

        // Ensure we have 12 slots; pad missing months with 0
        const normalizedPoints = Array.from({ length: 12 }, (_, idx) => Number(points[idx]) || 0);
        setTopCoinPoints(normalizedPoints);

        // Use current month only
        const currentMonthValue = Number(normalizedPoints[currentMonthIndex]) || 0;
        setTopCoinTotal(currentMonthValue);
      } catch (err) {
        console.error('Error fetching chart data:', err);
        setTopCoinPoints(Array(12).fill(0));
        setTopCoinTotal(0);
      } finally {
        setTopCoinLoading(false);
      }
    };

    fetchTopCoins();
  }, []);

  useEffect(() => {
    const fetchAllocatedDiscount = async () => {
      try {
        setAllocatedLoading(true);
        const response = await fetch(`${API_URL}/api/public/wallet/chart-data`);
        if (!response.ok) {
          throw new Error('Failed to fetch cash data');
        }

        const data = await response.json();

        let cashValues = [];
        if (Array.isArray(data?.cumulative_cash_values)) {
          cashValues = data.cumulative_cash_values;
        } else if (Array.isArray(data?.monthly_cash_values)) {
          cashValues = data.monthly_cash_values;
        } else if (Array.isArray(data?.monthly_data)) {
          cashValues = data.monthly_data.map((m) => Number(m?.cash_value) || 0);
        } else if (Array.isArray(data?.monthly_points)) {
          const rate = Number(data?.overall_stats?.conversion_rate) || 0.005;
          cashValues = data.monthly_points.map((p) => (Number(p) || 0) * rate);
        }

        const normalizedCash = Array.from({ length: 12 }, (_, idx) => Number(cashValues[idx]) || 0);

        // Use current month cash value only
        const currentMonthCash = Number(normalizedCash[currentMonthIndex]) || 0;

        setAllocatedAmount(currentMonthCash);
      } catch (err) {
        console.error('Error fetching cash data:', err);
        setAllocatedAmount(0);
      } finally {
        setAllocatedLoading(false);
      }
    };

    fetchAllocatedDiscount();
  }, []);

  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <PageTitle2 pageTitle={"My Wallet"} pagesub={"Home"} />

          <section className="wallet-page section_space pt-30 pb-5 mt-5 text-dark">
            <div className="container">
              <div className="row g-4">
                {/* Intro Card */}
                <div className="col-12">
                  <div className="wallet-card">
                    <h5 className="wallet-heading">My TopCoin Wallet</h5>
                    <p className="wallet-text">
                      Your <strong>TopCoin Wallet</strong> is where you can view, manage and keep track of the TopCoin and Bonus TopCoin you receive through the TopCoin UK loyalty and rewards platform.
                    </p>
                    <p className="wallet-text">
                      TopCoin and Bonus TopCoin are <strong>provided by TopCoin UK Ltd</strong> in accordance with the applicable programme rules.
                    </p>
                    <p className="wallet-text mb-0">
                      Your <strong>TopCoin Wallet is separate from your Captain TC Rewards Wallet</strong>. Each wallet has its own purpose and operates under its own programme rules.
                    </p>
                  </div>
                </div>

                {/* TopCoin Card */}
                <div className="col-12">
                  <div className="wallet-card">
                    <h6 className="wallet-title">TopCoin</h6>
                    <p className="wallet-text">
                      When you complete a qualifying purchase, promotion or other eligible activity, the applicable <strong>TopCoin</strong> may be added to your TopCoin Wallet.
                    </p>
                    <ul className="wallet-list mb-0">
                      <li>Is provided by <strong>TopCoin UK Ltd</strong>.</li>
                      <li>Is recorded in your <strong>TopCoin Wallet</strong>.</li>
                      <li>Is a digital loyalty and reward unit.</li>
                      <li>Is not a cryptocurrency or investment.</li>
                      <li>Can be used within the TopCoin UK rewards system, subject to the applicable rules.</li>
                    </ul>
                  </div>
                </div>

                {/* Bonus TopCoin Card */}
                <div className="col-12">
                  <div className="wallet-card">
                    <h6 className="wallet-title">Bonus TopCoin</h6>
                    <p className="wallet-text">
                      <strong>Bonus TopCoin</strong> is an additional promotional loyalty benefit that may be provided by TopCoin UK Ltd to eligible customers.
                    </p>
                    <p className="wallet-text">
                      Bonus TopCoin is recorded separately from your normal TopCoin and does not reduce or replace your TopCoin balance.
                    </p>
                    <p className="wallet-text mb-0">
                      The amount of Bonus TopCoin you receive may depend on qualifying customer activity, promotions and the applicable programme rules.
                    </p>
                  </div>
                </div>

                {/* 20,000 TopCoin Milestone Card */}
                <div className="col-12">
                  <div className="wallet-card">
                    <h6 className="wallet-title">20,000 TopCoin Milestone</h6>
                    <p className="wallet-text">
                      When an eligible customer's qualifying TopCoin balance reaches <strong>20,000 TopCoin</strong>, TopCoin UK Ltd will provide an additional <strong>5,000 TopCoin</strong>.
                    </p>
                    <p className="wallet-text">
                      The additional 5,000 TopCoin is added directly to the customer's <strong>TopCoin Wallet</strong>.
                    </p>
                    <p className="wallet-text fw-bold">
                      Example: 20,000 TopCoin + 5,000 TopCoin reward = 25,000 TopCoin in your TopCoin Wallet.
                    </p>
                    <p className="wallet-text">
                      The additional 5,000 TopCoin:
                    </p>
                    <ul className="wallet-list mb-0">
                      <li>Is added as <strong>TopCoin</strong>, not Bonus TopCoin.</li>
                      <li>Does <strong>not</strong> increase your Bonus TopCoin balance.</li>
                      <li>Does <strong>not</strong> generate or add any Captain TC Rewards TopCoin.</li>
                      <li>Does <strong>not</strong> count towards your Captain TC Rewards Wallet.</li>
                      <li>Remains within your <strong>TopCoin Wallet</strong> and is subject to the applicable TopCoin UK programme rules.</li>
                    </ul>
                  </div>
                </div>

                {/* Using Your TopCoin and Bonus TopCoin for Rewards Card */}
                <div className="col-12">
                  <div className="wallet-card">
                    <h6 className="wallet-title">Using Your TopCoin and Bonus TopCoin for Rewards</h6>
                    <p className="wallet-text">
                      Customers may use eligible <strong>TopCoin and Bonus TopCoin</strong> through the reward options made available by TopCoin UK.
                    </p>
                    <p className="wallet-text">
                      When you choose to use an eligible balance, you can select from the applicable <strong>TopCoin UK reward system</strong> available to you at that time.
                    </p>
                    <p className="wallet-text">
                      Available rewards may include <strong>physical gold, gift cards, eGift cards, vouchers, products, promotional benefits and other rewards</strong> offered by TopCoin UK Ltd.
                    </p>
                    <p className="wallet-text">
                      The reward options, eligibility requirements and amount of TopCoin or Bonus TopCoin required will be displayed or explained under the applicable reward programme rules.
                    </p>
                    <p className="wallet-text mb-0">
                      TopCoin and Bonus TopCoin are loyalty and reward units. Selecting a reward is a <strong>reward redemption</strong>, not a withdrawal of cash from a bank or cash account.
                    </p>
                  </div>
                </div>

                {/* Captain TC Rewards Wallet Card */}
                <div className="col-12">
                  <div className="wallet-card">
                    <h6 className="wallet-title">Captain TC Rewards Wallet</h6>
                    <p className="wallet-text fw-bold">
                      Your Captain TC Rewards Wallet is completely separate from your TopCoin and Bonus TopCoin balances.
                    </p>
                    <p className="wallet-text">
                      Customers with a valid and active <strong>Captain TC Rewards Card</strong> may receive Captain TC Rewards TopCoin from qualifying TopCoin activity, subject to the Captain TC Rewards Programme Terms & Conditions.
                    </p>
                    <p className="wallet-text mb-0">
                      Captain TC Rewards TopCoin is recorded in the <strong>Captain TC Rewards Wallet</strong> and is used to track progress towards Captain TC rewards.
                    </p>
                  </div>
                </div>

                {/* Important Card */}
                <div className="col-12">
                  <div className="wallet-card">
                    <h6 className="wallet-title">Important</h6>
                    <p className="wallet-text fw-bold">
                      The 5,000 TopCoin awarded for reaching 20,000 TopCoin in your TopCoin Wallet does not generate Captain TC Rewards TopCoin.
                    </p>
                    <p className="wallet-text fw-bold">
                      TopCoin Wallet: 20,000 + 5,000 = 25,000 TopCoin
                    </p>
                    <p className="wallet-text mb-0">
                      The additional <strong>5,000 TopCoin stays in your TopCoin Wallet only</strong>. No corresponding 5,000 Captain TC Rewards TopCoin is added to your Captain TC Rewards Wallet.
                    </p>
                  </div>
                </div>

                {/* Your Wallets Are Separate Card */}
                <div className="col-12">
                  <div className="wallet-card">
                    <h6 className="wallet-title">Your Wallets Are Separate</h6>
                    <p className="wallet-text">
                      <strong>TopCoin Wallet</strong> — records your TopCoin and applicable Bonus TopCoin and allows you to use eligible balances through available TopCoin UK reward options.
                    </p>
                    <p className="wallet-text">
                      <strong>Captain TC Rewards Wallet</strong> — separately records Captain TC Rewards TopCoin for customers with a valid and active Captain TC Rewards Card and tracks progress towards applicable Captain TC rewards.
                    </p>
                    <p className="wallet-text mb-0">
                      Balances displayed in one wallet do not automatically become balances in another wallet unless the applicable programme rules specifically state otherwise.
                    </p>
                  </div>
                </div>

                {/* Important Information Card */}
                <div className="col-12">
                  <div className="wallet-card">
                    <h6 className="wallet-title">Important Information</h6>
                    <p className="wallet-text">
                      TopCoin and Bonus TopCoin are provided and administered by <strong>TopCoin UK Ltd</strong> as part of the TopCoin UK loyalty and rewards programme.
                    </p>
                    <p className="wallet-text">
                      They are not bank deposits, savings products, cryptocurrency or investments.
                    </p>
                    <p className="wallet-text">
                      Reward availability, qualifying activity, milestone awards, Bonus TopCoin and redemptions are subject to the applicable <strong>TopCoin UK Terms & Conditions and programme rules</strong>.
                    </p>
                    <div className="text-center mt-4">
                      <p className="wallet-text fw-bold mb-1">TopCoin UK Ltd</p>
                      <p className="wallet-text fw-bold mb-0 opacity-75">Transparency • Trust • Loyalty Rewards</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
        <Scrollbar />
      </div>

      <style>{`
        .wallet-page {
           margin-top: 48px;
           padding-top: 72px;
        }

        .wallet-page {
          color: var(--bs-dark-text-emphasis, #1f2937);
        }

        .wallet-page .wallet-card {
          background: #ffffff;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 20px;
          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
          color: var(--bs-dark-text-emphasis, #1f2937);
        }

        .wallet-heading {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 12px;
          color: #111;
        }

        .wallet-title {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 10px;
          color: #111;
        }

        .wallet-subtitle {
          font-size: 16px;
          font-weight: 700;
          margin: 14px 0 8px;
          color: #111;
        }

        .wallet-label {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 6px;
          color: var(--bs-dark-text-emphasis, #1f2937);
        }

        .wallet-value {
          font-size: 16px;
          font-weight: 700;
          color: var(--bs-dark-text-emphasis, #0f172a);
          margin-bottom: 10px;
        }

        .wallet-inline-value {
          font-size: 16px;
          font-weight: 700;
          color: var(--bs-dark-text-emphasis, #0f172a);
          margin-left: 8px;
          display: inline;
        }

        .wallet-text {
          font-size: 16px;
          color: var(--bs-dark-text-emphasis, #1f2937);
          margin-bottom: 8px;
          line-height: 1.5;
        }

        .wallet-list {
          padding-left: 25px;
          margin-bottom: 10px;
          color: var(--bs-dark-text-emphasis, #1f2937);
          font-size: 16px;
          line-height: 1.5;
        }

        .wallet-list li {
          margin-bottom: 4px;
        }

        .wallet-footnote {
          font-size: 16px;
          color: #4b5563;
          margin-bottom: 0;
        }

        .notice-card {
          background: #f9fafb;
          border-color: #e5e7eb;
        }

        @media (max-width: 991px) {
          .wallet-page .wallet-card {
            padding: 16px;
          }

          .g-4, .gy-4 {
            --bs-gutter-y: 0rem; 
          }

          .wallet-heading {
            font-size: 17px;
          }

          .wallet-title {
            font-size: 15px;
          }

          .wallet-subtitle {
            font-size: 14px;
          }

          .wallet-text,
          .wallet-list,
          .wallet-label,
          .wallet-value {
            font-size: 13px;
          }
        }

        @media (max-width: 575px) {
          .wallet-page .wallet-card {
            padding: 14px;
          }

          .g-4, .gy-4 {
            --bs-gutter-y: 0rem; 
          }

          .wallet-heading {
            font-size: 16px;
          }

          .wallet-title {
            font-size: 14px;
          }

          .wallet-subtitle {
            font-size: 13px;
          }

          .wallet-text,
          .wallet-list,
          .wallet-label,
          .wallet-value {
            font-size: 12.5px;
          }
        }
      `}</style>
    </Fragment>        
  )
}

export default MyWalletPage